// Tipo para representar o intervalo [início, fim] em segundos
export type TimeInterval = [number, number];

/**
 * Funde intervalos de tempo sobrepostos ou adjacentes.
 */
export function mergeIntervals(intervals: TimeInterval[]): TimeInterval[] {
    if (intervals.length <= 1) return intervals;

    // 1. Ordena os intervalos pelo tempo de início
    const sortedIntervals = [...intervals].sort((a, b) => a[0] - b[0]);

    const merged: TimeInterval[] = [sortedIntervals[0]];

    // 2. Percorre e funde os intervalos sobrepostos
    for (let i = 1; i < sortedIntervals.length; i++) {
        const current = sortedIntervals[i];
        const lastMerged = merged[merged.length - 1];

        // Se o início do atual é menor ou igual ao fim do último adicionado...
        if (current[0] <= lastMerged[1]) {
            // Funde os dois, assumindo o maior valor de fim
            lastMerged[1] = Math.max(lastMerged[1], current[1]);
        } else {
            // Não há sobreposição, adiciona como um novo intervalo isolado
            merged.push(current);
        }
    }

    return merged;
}
